import { privateApi } from '../api';
import { createContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

const PermissionContext = createContext({
      loading: false,
      userPermissions: [],
      setUserPermissions: () => {},
      loadData: () => {}
});

export const PermissionContextProvider = (props) => {
      const [loading, setLoading] = useState(false);
      const [userPermissions, setUserPermissions] = useState([]);
      const [navigate, setNavigate] = useState(false);

      const token = JSON.parse(localStorage.getItem('token'));

      const loadData = async () => {
            setLoading(true);

            if (token) {
                  await privateApi
                        .get(`/auth/profile`)
                        .then((response) => {
                              setUserPermissions(
                                    response.data.user.permissions
                              );
                        })
                        .catch((error) => {
                              if (error.response.status === 401) {
                                    localStorage.removeItem('token');
                                    localStorage.removeItem('isLoggedIn');
                                    localStorage.removeItem('tokenExpiration');

                                    setNavigate(true);
                              }

                              console.log(error.message);
                        });
            }

            setLoading(false);
      };

      useEffect(() => {
            loadData();
      }, []);

      if (navigate) {
            // Perform logout actions here
            return <Navigate to="/" />;
      }

      const context = {
            loading: loading,
            userPermissions: userPermissions,
            setUserPermissions: setUserPermissions,
            loadData: loadData
      };

      return (
            <>
                  <PermissionContext.Provider value={context}>
                        {props.children}
                  </PermissionContext.Provider>
            </>
      );
};

export default PermissionContext;
